/*
	Define all data and data-interactions for the Application package.
*/

export const state = {
	packageVersion: require('../../../../package.json').version
};

export const getters = {
	appVersion: (state) => {
		return state.packageVersion;
	},
};

